// Google Ads conversion tracking.
export const GOOGLE_ADS_ID = "AW-18140119353";
export const GOOGLE_ADS_SIGNUP_LABEL = "MutNCJmIqbccELmC8clD";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const FIRED_KEY_PREFIX = "huelo:signup_conversion_fired:";

/** Fire the Google Ads SIGNUP conversion exactly once per user (per browser). */
export function fireSignupConversion(userId: string) {
  if (typeof window === "undefined" || !userId) return false;
  const key = FIRED_KEY_PREFIX + userId;
  try {
    if (localStorage.getItem(key)) return false;
  } catch {
    /* ignore */
  }

  try {
    window.gtag?.("event", "conversion", {
      send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_SIGNUP_LABEL}`,
      value: 1.0,
      currency: "USD",
    });
  } catch (err) {
    console.warn("[gtag] failed to fire signup conversion:", err);
  }


  try {
    localStorage.setItem(key, "1");
  } catch {
    /* ignore */
  }
  return true;
}
